import Vue from 'vue'
import axios from 'axios'
import objectFitImages from 'object-fit-images';
import SmoothScroll from 'smooth-scroll'
import Aos from 'aos'
import accordion from './utility/accordion'

var scroll = new SmoothScroll('a[href*="#"]');

/*******************
  AOS
*******************/
Aos.init({
  offset: 120,
  delay: 0,
  duration: 800,
  easing: 'ease-in',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
});


/*******************
  object fit
*******************/
objectFitImages('.img__cover img', {watchMQ: true});
objectFitImages('.bg__image-object img', {watchMQ: true});



let pictureCunstom = (el,num=1) => {
  const picture = document.querySelectorAll(el)
  Array.from(picture).forEach((v,i)=>{
    v.style.height = Math.round(v.clientWidth / num)+'px'
  })
}
pictureCunstom('.picture',1.618)
pictureCunstom('.square',1)



if(document.querySelector('.btn__nav')){
document.querySelector('.btn__nav').addEventListener('click',()=>{
  const el = document.querySelector('.sp-nav')
  if(!el.classList.contains('active')){
    el.classList.add('active')
  }else{
    el.classList.remove('active')
  }
},false)
}

/*******************
  tab
*******************/

if(document.getElementById('membercontent')){
  var membercontentInstance = new Vue({
    el: "#membercontent",
    data() {
      return {
        item: 'opinion',
        // item: 'pips',
        spread: 'gem',
        tp: 5,
        rikakuBafa: false,
        spreadManual: 0.0,
        currencyArray: '',
        currency: '',
        pipsRange: 0.1,
        targetCurrency: 'x',
        lot: 0.01,
        targetCurrencyRate: 0.0,
        currencyRate: 0.0,
        currencyLoss: 0,
        currencyDirection: 'long',
        indexDatas: [],

        post_data: {
          title:   '',
          content: ''
        },
        search_text: '',
        search_list: [],

        // 通貨保有lot数計算用 -----------------------------------------------------------------

          // ベース数値
            averagePips: [],            // 各通貨のベース数値一覧
            pipsJPY: 0.00,              // USD/JPYの直近一年間平均値幅（pips）

          // 基本設定
            basePayment: 1000000,       // 証拠金
            baseDays: 1,                // 日数
            baseLot: 0.60,              // lot

          // 保有可能lot
            possetionPayment: 100000, // 証拠金
            possetionDays: 3,           // 日数

          // 通貨設定
            pipsCurrency: [],           // 選択されている通貨

          // その他
            possetionCount: 0,          // ポジション数
            blank: 0,                   // computedが効かないdistributionの検知用

          // 集計期間
            totalPeriod: '1_month'         // 集計期間の初期設定
      }
    },
    methods: {
      //datasetの切り替え
      getItem(item){
        this.item = item
      },
      copy(text){
        navigator.clipboard.writeText(text)
        let target = document.querySelector('.coppied')
        target.classList.add('on')
        setTimeout(() => {
          target.classList.remove('on')
        }, 1500);
      },
      dotPosition(range){
        return range.length - range.indexOf('.')
      },
      //スプレッド計算（Long）
      spreadOption( position, range, direction, spread ){
        position = parseFloat(position)
        if( this.spreadManual != 0 ){                                     // 手動バッファが0ではない場合
          let spread = this.spreadManual * range                    // 利確幅 * 通貨の1pip幅
          if( direction == 'long' ){                                      //long
            let adjustmentPosition = position + parseFloat(spread)
            return adjustmentPosition.toFixed(this.dotPosition(range))
          }else{                                                          // short
              let adjustmentPosition = position - parseFloat(spread)
            return adjustmentPosition.toFixed(this.dotPosition(range))
          }
        }else{                                                            // バッファが0の場合はそのままのポジションを小数点を調整して表示
          return position.toFixed(this.dotPosition(range))
        }
      },
      // 利確位置計算（spread抜き）
      takeProfit( position, range, direction ){
        let pips = this.tp * range // 利確幅 * 通貨の1pip幅
        let tp   = 0
        if(direction=='long'){
          tp = parseFloat(position) + parseFloat(pips)
        }else{
          tp = parseFloat(position) - parseFloat(pips)
        }
        return tp.toFixed(this.dotPosition(range))
      },

      // 投稿の取得 -----------------------------------------------------------------

        getPost(params) {
          const param = new URLSearchParams(params)
          axios.get(`${path}posts`, param)
          .then((res) => {
            this.post_data.title   = res.data[0].title.rendered
            this.post_data.content = res.data[0].content.rendered
          })
        },
        getPostAsDataText(text) {
          axios.get(`${path}posts?per_page=1&title=${text}`)
          .then((res) => {
            this.post_data.title   = res.data[0].title.rendered
            this.post_data.content = res.data[0].content.rendered
          })
          .catch(error => {
            console.log(error.response)
          })
        },
        changePost(id) {
          axios.get(`${path}posts/${id}`)
          .then((res) => {
            this.post_data.title   = res.data.title.rendered
            this.post_data.content = res.data.content.rendered
          })
        },



      // 通貨保有lot数計算用 -----------------------------------------------------------------


      // ベース数値取得 -------------------

        // 対ドル円の平均値幅差計算
        getDisparity( dataCurrency ) {
          if (dataCurrency.currency.post_title != 'USD/JPY') {
            return parseFloat( this.getTotalPreiod(dataCurrency) - this.pipsJPY ).toFixed(2)
          } else {
            return 0
          }
        },

        // 対ドル円の平均比率計算
        getAgainst( dataCurrency ) {
          if (dataCurrency.currency.post_title != 'USD/JPY') {
            return ( ( this.getTotalPreiod(dataCurrency) / this.pipsJPY ) - 1 ).toFixed(4)
          } else {
            return 0
          }
        },

        // lot割合計算
        percentageLot( dataCurrency ) {
          if (dataCurrency.currency.post_title != 'USD/JPY') {
            return parseFloat( this.pipsJPY / this.getTotalPreiod(dataCurrency) ).toFixed(4)
          } else {
            return 0
          }
        },

        // 各通貨保有時の各通貨のベースlot（エントリーlot）
        mathEntryLot(entryLot) {
          let output = 0
          this.averagePips.forEach((x) => {
            if (x.currency == 'USD/JPY') {
              output = entryLot
            } else {
              output = (entryLot * x.percentageLot).toFixed(2)
            }
            x.entryLot = Number(output)
          })
        },

        // 直近一年間の平均値幅（pips）の取得
        getCurrency() {
          axios.get(pathACF)
          .then((res) => {
            const averagePips = res.data.acf.averagePips
            let array         = []
            this.averagePips  = []
            this.$nextTick(() => {
              averagePips.forEach((x) => {
                if (x.currency.post_title == 'USD/JPY') {
                  this.pipsJPY = this.getTotalPreiod(x)
                }
                array = {
                  currency:      x.currency.post_title,  // 通貨名
                  pips:          Number(this.getTotalPreiod(x)), // 直近一年間の平均値幅
                  disparity:     Number(this.getDisparity( x )), // ドル円との差異
                  against:       Number(this.getAgainst( x )),   // 対ドル円に平均比率
                  percentageLot: Number(this.percentageLot(x)),  // lot割合
                  maxLot:        0,                              // 最大Lot
                  firstPossetion: 0,                             // 1ポジション目
                }
                this.averagePips.push(array)
              })
            })
          })
        },

        // 集計期間ごとのデータreturn
        getTotalPreiod(data) {
          switch (this.totalPeriod) {
            case 'year':
              return data.pips_year
            case '3_month':
              return data.pips_3month
            case '1_month':
              return data.pips_1month
            default:
              return data.pips_year
          }
        },


      // 計算用 -------------------------

        // 計算：倍率
        numbeScale( scale ) {
          let base = '1'
          for (var i = 1; i <= scale; i++) base += String(0)
          return Number(base)
        },

        // 計算：四捨五入
        rounding(number, scale = 3) {
          let newNumber = Math.round(number * this.numbeScale(scale))
          return newNumber / this.numbeScale(scale)
        },

        // 計算：切り上げ
        ceil( number, scale = 3 ) {
          let newNumber = Math.ceil(number * this.numbeScale(scale))
          return newNumber / this.numbeScale(scale)
        },


      // 算出用 -------------------------

        // 1ポジ目のlot計算
        mathFirstPossetion( sum ) {
          let output = 0
          this.averagePips.forEach((x) => {
            output           = (x.maxLot / sum).toFixed(2)
            x.firstPossetion = Number(output)
          })
        },

        // 最大Lot計算
        mathMaxLot() {
          let output = 0
          this.averagePips.forEach((x) => {
            if (this.pipsCurrency.length) {
              output = (x.entryLot / this.pipsCurrency.length).toFixed(2)
            }else{
              output = 0
            }
            x.maxLot = Number(output)
          })
        },

        // ポジションごとのlot計算
        mathEachPossetionLot(firstPossetion, index) {
          let output = this.rounding(index * firstPossetion, 2)
          if(output != Infinity) return output.toFixed(2)
        },

        // checkbox解除ボタン（応急処置用）
        clearCheckbox() {
          this.pipsCurrency = []
        },


      // 指標発表 -------------------------

        getRelease() {
          // 元ファイルの取得先（旧）: https://www.okasan-online.co.jp/tradeinfo/indicator_event/economic_indicators/thismonth.html
          // 元ファイルの取得先（新）: https://www.fxshihyo.com/ or https://www.fxshihyo.com/ar/day20221207.php etc...
          axios.get(`//iwsfx.xsrv.jp/apis/data/index_release.json`)
          .then((res) => {
            this.indexDatas = res.data
          })
          .catch(e => {
            console.log(e)
          })
        },

        getStar(str) {
          const s_n = '<span>☆</span>'
          const s_1 = '<span class="fill">★</span>'
          const s_h = '<span class="icon-star-half"></span>'
          const str_length = str.length
          switch (str_length) {
            case 1:    return `${s_1}${s_n}${s_n}`;
            case 2:    return `${s_1}${s_1}${s_n}`;
            case 3:    return `${s_1}${s_1}${s_1}`;
            case 4:    return `${s_1}${s_1}${s_1}${s_1}`;
            case 5:    return `${s_1}${s_1}${s_1}${s_1}${s_1}`;
            default:   return `${s_n}${s_n}${s_n}`;
          }
        },

        getDay(date) {
          const weekChars = ["(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)"]
          const dateObj   = new Date(date)
          const weekDay   = dateObj.getDay()
          return weekChars[weekDay]
        },

        getFlag(src) {
          const domain = '//trader-fx.net'
          switch (src) {
            case 'china':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-cny.svg`; // 中国
            case 'eu':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-eur.svg`; // ユーロ
            case 'turkey':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-try.svg`; // トルコ
            case 'france':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-fr.svg`;  // フランス
            case 'Germany':   return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-gm.svg`;  // ドイツ
            case 'uk':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-gbp.svg`; // イギリス
            case 'canada':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-cad.svg`; // カナダ
            case 'usa':       return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-usd.svg`; // アメリカ
            case 'australia': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-aud.svg`; // オーストラリア
            case 'm_afrika':  return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-zar.svg`; // 南アフリカ共和国
            case 'japan':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-jpy.svg`; // 日本
            case 'swiss':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-chf.svg`; // スイス
            case 'nz':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-nzd.svg`; // ニュージーランド

            // 前サイトにて使用（使用はされていないが、突然使用し始めた時用に残しておく）
            case 'br': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-brl.svg`; // ブラジル
            case 'hk': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-hkd.svg`; // 香港
            case 'in': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-inr.svg`; // インド
            case 'kr': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-krw.svg`; // 韓国
            case 'mx': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-mxn.svg`; // メキシコ
            case 'no': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-nok.svg`; // ノルウェー
            case 'ru': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-rub.svg`; // ロシア
            case 'se': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-sek.svg`; // スウェーデン
            case 'sg': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-sgd.svg`; // シンガポール
            case 'pl': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-plz.svg`; // ポーランド
            case 'de': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-usd.svg`;
            default:   return ``;
          }
        }

    },
    mounted() {
      // 「＃」によるURL付与
      if (location.hash ) {
        // https://......#hoge があれば hoge を this.itemに代入
        this.item = location.hash.slice(1)
      }
      // 初期投稿の取得
      this.getPost({
        per_page: 1
      })
      accordion(300, 'datelist__label')
      // lot管理用
      this.getCurrency()
      // 指標発表用
      this.getRelease()
    },
    computed: {
      mathCurrency() {
        if (this.targetCurrencyRate != 0) {
          var yen = this.lot * this.targetCurrencyRate * 10
          return Math.ceil(yen)
        } else {
          return 0
        }
      },
      currencyClear() {
        if (this.currencyLoss != 0) {
          var loss = this.currencyLoss / this.mathCurrency
          return Math.ceil(loss)
        } else {
          return 0
        }
      },
      currencyClearRate() {
        if( this.currencyLoss != 0 ){
          var getPips = this.currencyClear * this.pipsRange
          if (this.currencyDirection == 'long') {
            var clearRate = parseFloat(this.currencyRate) + getPips
          } else {
            var clearRate = parseFloat(this.currencyRate) - getPips
          }
          return clearRate.toFixed(this.dotPosition(this.pipsRange))
        }
      },
      isJPY() {
        const currency = this.currency.split('/')[1]
        return currency == 'JPY' ? true : false
      },

      // lot管理 -----------------------------------------------------------------

      // 通貨保有lot数計算用 -----------------------------------------------------------------

        // 分配数計算
        distribution: {
          get: function () {
            let length = this.possetionCount
            let sum    = 0
            for (var i = 0; i <= length; i++) {
              sum += i
            }
            this.mathFirstPossetion(sum)
            return sum
          },
          set: function(newValue) {
            return newValue
          }
        },
        possetionLot: {
          get: function(){
            let payment      = this.possetionPayment / this.basePayment
            let days         = this.baseDays / this.possetionDays
            let possetionLot = (this.baseLot * (payment * days)).toFixed(2)
            this.mathEntryLot(possetionLot)
            this.mathMaxLot()
            this.blank = this.distribution // computedが反応しないため
            return possetionLot
          },
          set: function(newValue) {
            return newValue
          }
        }
    },
    watch: {
      currencyArray() {
        var split      = this.currencyArray.split(',')
        this.currency  = split[0]
        this.pipsRange = split[1]
      },
      currency() {
        var split = this.currency.split('/')[1]
        if (split != 'JPY' && split != 'jpy') {
          this.targetCurrency = `${split}/JPY`
          this.targetCurrencyRate = 0
        } else {
          this.targetCurrency = this.currency
          this.targetCurrencyRate = 100
        }
      },
      search_text() {
        if (this.search_text === '') {
          this.search_list = []
          return
        }
        let searchText = this.search_text.replace(/ |　/g, '+')
        searchText = encodeURIComponent(searchText)
        axios.get(`${path}posts?per_page=30&search=${searchText}`)
        .then((res) => {
          // console.log(res.data)
          this.search_list = res.data
        })
      },

      // lot管理 -----------------------------------------------------------------

        // ポジション数変更による最大lot数の割り出し
        possetionCount() {
          this.possetionCount = Number(this.possetionCount)
          this.blank = this.distribution // computedが反応しないため
        },

        // 通貨数変更による最大lot数の割り出し
        pipsCurrency() {
          this.mathMaxLot()
          this.blank = this.distribution // computedが反応しないため
        },

        // 集計期間変更による再集計
        totalPeriod() {
          this.getCurrency()
          this.possetionLot()
        }
    }
  })
}




/*******************
  FAQ
*******************/
document.addEventListener('click', (e) => {
  if(e.target.classList.contains('faq__q')){
    if(!e.target.classList.contains('active')){
      e.target.classList.add('active')
    }else{
      e.target.classList.remove('active')
    }
  }
},false)



/*******************
  gallery
*******************/

if(document.getElementById('gallery')){
  var flowInstance = new Vue({
    el: "#gallery",
    data() {
      return {
        img: initialImage,
      }
    },
    methods: {
      //datasetの切り替え
      changeImage(item){
        this.img = item
        flowInstance.item = item
      },
    },
  })
}



/*******************
  archives
*******************/

if(document.getElementsByClassName('archives')){
  Array.from(document.getElementsByClassName('archives')).map((x,i)=>{
    const archivesInstance = new Vue({
      el: ".archives",
      data() {
        return {
          dataOrigin: [],
          datas: [],
          dataBase: [],
          pager: 1,
          total: 1,
          category:[],
          searchCategory: [],
          flag: true,
          totalPost: 0,
          totalPage: 0,
          searchFlag: false,

          perPage: 0,
          post_type: "",
          taxonomy: "",
          query: "",
          max_post: 0
        }
      },
      methods: {
        Pager(n){
          this.$el.getElementsByClassName('content-pager__page')[this.pager-1].classList.remove('content-pager__page_active')
          this.pager = n
          this.$el.getElementsByClassName('content-pager__page')[this.pager-1].classList.add('content-pager__page_active')
        },
        getPosts(page){
          const promise = new Promise((resolve, reject) => {
            axios.get(path + this.post_type +'?_embed&page='+page+this.query)
            .then( (res) => {
              this.$nextTick(()=>{
                resolve(res.data)
              })
            })
          })
          return promise
        },
        getImgUrl(data,imagesize){
          const imageSize = imagesize
          if(data._embedded && 
              data._embedded['wp:featuredmedia'] &&
              data._embedded['wp:featuredmedia'][0].media_details &&
              data._embedded['wp:featuredmedia'][0].media_details.sizes[imageSize]){
            return data._embedded['wp:featuredmedia'][0].media_details.sizes[imagesize].source_url
          }else{
            return false
          }
        },
        separate(data,text){ // 丸宮商店用
          var html = data.content.rendered
          html = html.split('</p>')[0]
          html = html.replace(/<p>/g, '')
          html = this.getItem(html,text)
          return html
        },
        getItem(html,text){ // 丸宮商店用
          // var item = html.match(/【.+】.+<br \/>/g)
          var regexp = new RegExp('【' + text + '】(.+)<br \/>')
          return html.match(regexp) ? html.match(regexp)[1] : '-'
        },
        title(data,num) {
          var text = data.title.rendered;
          return text.replace(/<(".*?"|'.*?'|[^'"])*?>/g, '').replace(/<br \/>/g, '').slice(0,num) + '…';
        },
      },
      mounted(){
        if(typeof this.$el.dataset.perpage !== 'undefined') this.perPage = this.$el.dataset.perpage
        if(typeof this.$el.dataset.taxonomy !== 'undefined') this.taxonomy = this.$el.dataset.taxonomy
        if(typeof this.$el.dataset.post_type !== 'undefined') this.post_type = this.$el.dataset.post_type
        if(typeof this.$el.dataset.query !== 'undefined') this.query = this.$el.dataset.query
        if(typeof this.$el.dataset.max_post !== 'undefined') this.max_post = this.$el.dataset.max_post

        // if(typeof repair_id !== 'undefined') this.query += '&categories='+repair_id
        // if(typeof author_id !== 'undefined' && page_flag != "cat") this.query += '&author='+author_id

        if(this.taxonomy){
          axios.get(path + this.taxonomy + '?per_page=100')
          .then( (res) => {
            this.category = res.data.filter((x)=>{return x.name != "未分類"})
          })
        }

        axios.get(path + this.post_type +'?_embed&page=1'+this.query)
        .then( (res) => {
          this.dataOrigin = res.data
          this.datas = this.dataOrigin.slice(0,this.perPage)
          if(this.max_post != 0){
            this.total = Math.ceil(this.max_post / this.perPage)
            if(this.totalPage > res['headers']['x-wp-totalpages']){
              this.totalPage = Math.ceil(this.max_post / 10)
            }else{
              this.totalPage = res['headers']['x-wp-totalpages']
            }
          }else{
            this.total = Math.ceil(res['headers']['x-wp-total'] / this.perPage)
            this.totalPage = res['headers']['x-wp-totalpages']
          }
          // this.totalPost = res['headers']['x-wp-total']
          this.$nextTick(()=>{
            (async () => {
              for (let i = 2; i <= (this.totalPage); i++) {
                const result = await this.getPosts(i)
                result.map((x)=>{
                  this.dataOrigin.push(x)
                  this.dataBase.push(x)
                })
              }
              // this.datas = this.dataBase.slice(0,this.perPage)
              // this.dataBase = this.dataOrigin
              this.searchFlag = true
              if(!res.data.length) this.flag = false
            })()

          })
        })

      },
      watch: {
        pager() {
          let before = 0
          let after = 0
          before = this.pager==1 ? this.pager-1 : (this.pager-1)*this.perPage
          if(this.pager*this.perPage > this.dataBase.length){
            after = this.dataBase.length
          }else{
            after  = this.pager==1 ? this.pager*this.perPage : this.pager*this.perPage
          }
          this.datas = this.dataBase.slice(before,after)
        },
        searchCategory() {
          if(this.dataBase.length > this.perPage){
            this.$el.getElementsByClassName('content-pager__page_active')[0].classList.remove('content-pager__page_active')
            this.pager = 1
            this.$el.getElementsByClassName('content-pager__page')[0].classList.add('content-pager__page_active')
          }
          if(this.searchCategory.length==0){
            this.dataBase = this.dataOrigin
            this.datas = this.dataBase.slice(0,this.perPage)
            this.total = Math.ceil(this.dataBase.length / this.perPage)
          }else{
            let tax = this.taxonomy
            this.dataBase = this.dataOrigin.filter((x)=>{
              let array1 = x[tax].concat(this.searchCategory)
              let array2 = Array.from(new Set(array1))
              return array1.length != array2.length
            })
            this.total = Math.ceil(this.dataBase.length / this.perPage)
            this.datas = this.dataBase.slice(0,this.perPage)
          }
          this.flag = this.datas.length ? true : false
        }
      }
    })
  })
}

